import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "other-info" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_data_input = _resolveComponent("data-input")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_popup = _resolveComponent("popup")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    current: 2,
    isDisabled: _ctx.isDisabled,
    form: { checked: _ctx.checked },
    prePathName: "risk"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "其他资料申报", -1)),
        _createVNode(_component_van_checkbox_group, {
          modelValue: _ctx.checked,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
          onChange: _ctx.checkboxChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkedContent, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value
              }, [
                (item.value !== 24)
                  ? (_openBlock(), _createBlock(_component_van_checkbox, {
                      key: 0,
                      shape: "square",
                      name: item.value
                    }, {
                      default: _withCtx(() => [
                        (item.value == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                              _createTextVNode(_toDisplayString(item.text.split('主')[0]) + " ", 1),
                              _createElementVNode("span", {
                                class: "yellow",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openPop(0)), ["stop"]))
                              }, "主要股东")
                            ]))
                          : (item.value == 5)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                                _createTextVNode(_toDisplayString(item.text.split('政')[0]) + " ", 1),
                                _createElementVNode("span", {
                                  class: "yellow",
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openPop(1)), ["stop"]))
                                }, "政治人物"),
                                _createTextVNode(" " + _toDisplayString(item.text.slice(14, 23)) + " ", 1),
                                _createElementVNode("span", {
                                  class: "yellow",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openPop(2)), ["stop"]))
                                }, "联系或关系")
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.text), 1))
                      ]),
                      icon: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(
                  `iconfont ${
                    _ctx.checked.includes(item.value)
                      ? 'icon-duoxuanxuanzhong'
                      : 'icon-duoxuanweixuanzhong'
                  }`
                )
                        }, null, 2)
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_data_input, {
                  checked: _ctx.checked,
                  name: item.value,
                  imagesList: _ctx.imagesList
                }, null, 8, ["checked", "name", "imagesList"])
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"]),
        _createVNode(_component_popup, {
          show: _ctx.show,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.show) = $event)),
          onClosePopup: _ctx.closePopup,
          onClickOverlay: _cache[5] || (_cache[5] = () => (_ctx.show = false)),
          title: _ctx.title,
          content: _ctx.content
        }, null, 8, ["show", "onClosePopup", "title", "content"])
      ])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "form"]))
}